import React, { Component } from "react";
import { EditButton, RemoveButton, NewButton } from "../common/customButtons";
import { ButtonGroup, Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { toast } from "react-toastify";
import projetoService from "../services/projetoService";
import BootstrapTable from "react-bootstrap-table-next";
import CustomModal from "../common/customModal";
import Placeholder from "../common/placeholder";
import { NavigateFunction, Params, useNavigate, useParams } from "react-router-dom";

//import ButtonGroup from "@material-ui/core/ButtonGroup";



interface ProjetosProps {
  history: NavigateFunction,
  params: Readonly<Params<string>>,

}

interface ProjetState {
  projetos: Projeto[],
  removeModal: boolean,
  projetoToBeRemoved: Projeto,
  ready: boolean,
}

class Projetos extends Component<ProjetosProps, ProjetState> {
  columns = [
    {
      dataField: "key",
      text: "key",
      hidden: true,
    },
    {
      dataField: "nomeProjeto",
      text: "Projeto",
    },
    {
      dataField: "coordenadorChefeNome",
      text: "Coordenador",
    },
    {
      dataField: "instituicaoExecutora",
      text: "Instituição Executora",
    },
    {
      dataField: "functions",
      text: "",
      style: { "white-space": 'nowrap' },
      isDummyField: true,
      formatter: (cell, row) => (
        <React.Fragment>
          <ButtonGroup>
          <EditButton
            className="text-white"
            size="sm"
            onClick={() => this.handleClickEdit(row)}
          />
          <RemoveButton size="sm" onClick={() => this.handleClickRemove(row)} />
          </ButtonGroup>
        </React.Fragment>
      ),
    },
  ];

  async componentDidMount() {
    const { data: projetos } = await projetoService.getProjetos();

    this.setState({ projetos, ready: true });
  }

  handleClickEdit = ({ projetoId }) => {
    this.props.history(`/gerenciamento/projetos/${projetoId}`);
  };

  handleClickRemove = (projeto) => {
    const projetoToBeRemoved = { ...projeto };
    this.setState({ projetoToBeRemoved });
    this.handleToggleModal();
  };

  doRemove = async () => {

    const originalProjetos = this.state.projetos;
    const { projetoId } = this.state.projetoToBeRemoved;

    this.setState({
      projetos: originalProjetos.filter((u) => u.projetoId !== projetoId),
    });

    this.handleToggleModal();

    try {
      await projetoService.deleteProjeto(projetoId);
      toast.success("Projeto removido.");
    } catch (ex) {
      if (ex.response) {
        if (ex.response.status === 404) {
          toast.error("Esse Projeto já foi removido.");
        } else if (ex.response.status === 400) {
          toast.error(ex.response.data);
        }
      }
      this.setState({ projetos: originalProjetos });
    }
  };

  handleToggleModal = () => {
    this.setState({ removeModal: !this.state.removeModal });
  };

  handleClickNew = () => {
    this.props.history("/gerenciamento/projetos/novo");
  };

  state = {
    projetos: [],
    removeModal: false,
    projetoToBeRemoved: undefined,
    ready: false,
  };

  render() {
    const { projetos, removeModal, projetoToBeRemoved, ready } = this.state;

    console.log("Projetos", { removeModal })
    return (


      <div className="animated fadeIn" style={{
        overflowY: "scroll",
        overflowX: "hidden"
      }}>
        {removeModal &&
          <CustomModal
            headerTitle="Remover Projeto"
            bodyText={
              <span>
                Você tem certeza que deseja remover o projeto:{" "}
                <b>{projetoToBeRemoved.nomeProjeto}</b>?
              </span>
            }
            onToggle={this.handleToggleModal}
            CustomButton={RemoveButton}
            onClick={this.doRemove}
            isOpen={removeModal}

          />
        }
        <Row>
          <Col>
            <Card>
              <Placeholder ready={ready}>
                <CardHeader className="bg-light">
                  <i className="fa fa-align-justify" /> Projetos
                </CardHeader>
                <CardBody>
                  <NewButton
                    className="mb-3"
                    text="Novo projeto"
                    onClick={this.handleClickNew}
                  />
                  <BootstrapTable
                    bootstrap4
                    keyField="key"
                    data={projetos}
                    columns={this.columns}
                    bordered={false}
                    hover
                    noDataIndication="Nenhum Projeto Cadastrado"
                    classes="table-responsive"
                    rowClasses="animated fadeIn"
                  />
                </CardBody>
              </Placeholder>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

// export default Projetos;
export default (props) => (
  <Projetos history={useNavigate()} params={useParams()} />
);
